import React, { useState, useEffect } from "react";
import Spinner from "../../Components/Spinner/Spinner";
import SearchBar from "../../Components/SearchBar/SearchBar";
import BookingCard from "../../Components/BookingCard/BookingCard";
import {
    scrollToJob,
    handleMultiDateBookings,
    statusList,
    dateList,
    sortListAll,
    sortListPast,
    filterByDate,
    filterByKeyword,
    filterByStatus,
    submitResponse,
    getRefId,
} from "./Helper";
import { API } from "../../API";
import "./JobList.css";
import JumpToTopButton from "../../Components/Buttons/JumpToTopButton";
import { notify } from "react-notify-toast";
import { teacherResponse } from "../../Helper";
import InfiniteScroll from "react-infinite-scroller";

function TeacherJobListNewContent(props) {
    let [isLoaded, setIsLoaded] = useState(false);
    let [isLoading, setIsLoading] = useState(false);
    let [allBookings, setAllBookings] = useState([]);
    let [allCampus, setAllCampus] = useState([]);
    let [allInst, setAllInst] = useState([]);
    let [allClasses, setAllClasses] = useState([]);
    let [showCurrentBookings, setShowCurrentBookings] = useState([]);
    let [refs, setRefs] = useState({});
    let [searchKeyword, setKeyword] = useState("");
    let [searchDate, setDate] = useState("date-all");
    let [searchStatus, setStatus] = useState("status-all");
    let [sortType, setSortType] = useState("sort-date-desc");
    let [requestDayOff, setRequestDayOff] = useState(false)
    const [hasMore, setHasMore] = useState(true)
    const [bookingsData, setBookingsData] = useState([])
    const [isLoadCampus, setIsLoadCampus] = useState(true)
    const [keyLoad, setReload] = useState(null)
    const [qualifications, setQualifications] = useState([])

    let sortList = searchDate === "date-all" ? sortListAll : sortListPast;
    let bookingId;
    let dateIndex;

    //Get access to all the bookings of the current user

    useEffect(() => {
        fetchAllBookingsFirstTime(1, 20, searchStatus, sortType);
        getQualifications()
    }, [])

    const fetchAllBookingsFirstTime = async (page, limit = 20, status = searchStatus, isSortType = sortType) => {
        setIsLoading(true)
        getBookingID();
        getDateIndex();
        if(dateIndex) {
            setRequestDayOff(true)
            await API.splitBookingForCancelSingleDate(bookingId, dateIndex)
        }
        const result = await API.fetchBookingsByTeacherIDWithPagination(page, limit, props.user._id, isSortType);
        

        let list = handleMultiDateBookings(result?.data?.data, props.user._id);
        if(bookingId) {
            list = list.filter(item => item._id === bookingId)
        }
        if(dateIndex) {
            list = list.filter(item => item.booking_date === item.dates[dateIndex].date)
        }
        list = sort(list, sortType);

        let allRefs = { ...refs };
        list.forEach((booking) => {
            let id = getRefId(booking);
            allRefs[id] = React.createRef();
        });
        setRefs(allRefs);

        list = filterByStatus(list, status);
        setBookingsData(preState => ([...preState, ...list]))
        if (isLoadCampus) {
            getAllCampus();
            setIsLoadCampus(false);
        }
        setAllBookings(preState => ([...preState, ...list]));

        // if (dateIndex) {
        //     setRequestDayOff(true)
        //     API.splitBookingForCancelSingleDate(bookingId, dateIndex).then((res) => {
        //         list = list.filter(b => b._id === bookingId && b.booking_date === b.dates[dateIndex]?.date)
        //         if (list.length === 0) {
        //             // fetchAllBookings(page, limit, props.user._id);
        //         } else {
        //             setShowCurrentBookings(list);
        //             // setHasMore(true);
        //         }
        //     }).catch((err) => {
        //         console.log(err);
        //     })
        // } else {
        //     setShowCurrentBookings(list);
        //     // setHasMore(true);
        // }
        // setLoading(false)
        setIsLoading(false)
    }

    const getQualifications = () => {
        API.getQualificationList()
            .then((res) => {
                setQualifications(res?.data?.data)
            })
            .catch((error) => {
                console.log(('error get qualifications list', error))
            })
    }

    const fetchAllBookings = async (page, limit = 20, status = searchStatus, date = searchDate, isSortType = sortType) => {
        setIsLoading(true)
        setHasMore(false)
        getBookingID();
        getDateIndex();
        if (dateIndex) return;

        const result = await API.fetchBookingsByTeacherIDWithPagination(page, limit, props.user._id, isSortType);

        let list = handleMultiDateBookings(result?.data?.data, props.user._id);
        list = sort(list, sortType);

        let allRefs = { ...refs };
        list.forEach((booking) => {
            let id = getRefId(booking);
            allRefs[id] = React.createRef();
        });
        setRefs(allRefs);

        list = filterByStatus(list, status);
        list = filterByDate(list, date);
        setBookingsData(preState => ([...preState, ...list]))
        if ((result?.data?.paginate.page < result?.data?.paginate.total_page)) {
            setHasMore(true);
        } else {
            setHasMore(false);
        }

        if (isLoadCampus) {
            getAllCampus();
            setIsLoadCampus(false);
        }
        setAllBookings(preState => ([...preState, ...list]));
        setIsLoading(false)
    }

    const getAllCampus = () => {
        API.getAllCampus()
            .then(function (result) {
                setAllCampus(result.data);
                getAllInst();
            })
            .catch(function (err) {
                console.log(err);
            });
    };

    const getAllInst = () => {
        API.getAllInst()
            .then(function (result) {
                setAllInst(result.data);
                getAllClass();
            })
            .catch(function (err) {
                console.log(err);
            });
    };

    const getAllClass = () => {
        API.getAllClasses()
            .then(function (result) {
                setAllClasses(result.data);
                // setIsLoaded(true);
            })
            .catch(function (err) {
                console.log(err);
            });
    };

    const getBookingID = () => {
        let pathname = window.location.href;
        let urlArray = pathname.split("#");
        bookingId = urlArray[1]?.split("_")[0];
    }

    const getDateIndex = () => {
        let pathname = window.location.href;
        let urlArray = pathname.split("#");
        dateIndex = urlArray[1]?.split("_")[1];
    }

    const sort = (list, sType) => {
        // console.log("sorting by: " + sType)
        let sortedList = list;
        switch (sType) {
            case "sort-date-desc":
                sortedList = list.sort((jobA, jobB) => {
                    if (jobA.booking_date === jobB.booking_date) {
                        let endBookingDateA = jobA.end_booking_date || jobA.booking_date;
                        let endBookingDateB = jobB.end_booking_date || jobB.booking_date;
                        if (endBookingDateA === endBookingDateB) {
                            return jobA.arrival_time < jobB.arrival_time ? 1 : -1;
                        } else return endBookingDateA < endBookingDateB ? 1 : -1;
                    } else return jobA.booking_date < jobB.booking_date ? 1 : -1;
                });
                break;
            case "sort-date-asc":
                sortedList = list.sort((jobA, jobB) => {
                    if (jobA.booking_date === jobB.booking_date) {
                        let endBookingDateA = jobA.end_booking_date || jobA.booking_date;
                        let endBookingDateB = jobB.end_booking_date || jobB.booking_date;
                        if (endBookingDateA === endBookingDateB) {
                            return jobA.arrival_time > jobB.arrival_time ? 1 : -1;
                        } else return endBookingDateA > endBookingDateB ? 1 : -1;
                    } else return jobA.booking_date > jobB.booking_date ? 1 : -1;
                });
                break;
            default:
                break;
        }

        return sortedList;
    };

    const search = ({ keyword, status, date }) => {
        const st = status || searchStatus;
        const d = date || searchDate;
        const k = (keyword === undefined ? searchKeyword : keyword).toLowerCase();
        let filteredBookings = filterByStatus(allBookings, st);
        filteredBookings = filterByDate(filteredBookings, d);
        filteredBookings = filterByKeyword(filteredBookings, k, allCampus, allInst, []);
        if (d === "future" || d === "in-progress") {
            filteredBookings = sort(filteredBookings, "sort-date-asc");
        } else filteredBookings = sort(filteredBookings, sortType);
        setBookingsData(filteredBookings);
    };

    const onSearchStatus = (e) => {
        const status = e.target.id;
        setStatus(status);
        setBookingsData([]);
        setAllBookings([]);
        setReload(new Date().getTime());
        // search({ status });
    };

    const onCancelJob = () => {
        setStatus("cancelled");
        // search({ status: "cancelled" });
        setReload(new Date().getTime());
    };

    const onAcceptJob = () => {
        setStatus("accepted");
        setReload(new Date().getTime());
    };

    const onRejectJob = () => {
        setStatus("rejected");
        setReload(new Date().getTime());
    };

    useEffect(() => {
        if (keyLoad === null) return;
        fetchAllBookings(1, 20, searchStatus, searchDate, sortType);
    }, [keyLoad]);

    const onSearchDate = (e) => {
        const date = e.target.id;
        setDate(date);
        setBookingsData([]);
        setAllBookings([]);
        setReload(new Date().getTime());
    };

    const handleBookings = (newBookings) => {
        setAllBookings(newBookings);
        search({});
    };

    const onSearchKeyword = (e) => {
        const keyword = e.target.value;
        setKeyword(keyword);
        search({ keyword });
    };

    const onSort = (e) => {
        const sType = e.target.id;
        setSortType(sType);
        setBookingsData([]);
        setAllBookings([]);
        setReload(new Date().getTime());
    };

    const handleRequestDayOff = (booking) => {
        getDateIndex();
        let split_index = booking.splits.findIndex(
            split => {
                return split.date_from <= booking.booking_date && split.date_to >= booking.booking_date
            })

        API.requestDayOff(booking._id, split_index, dateIndex)
            .then(() => {
                let newBookings = showCurrentBookings.map(b => {
                    let updatedBooking = b;
                    if (b._id === booking._id) {
                        updatedBooking.teacher_response = teacherResponse.rejected
                    }
                    return updatedBooking
                })
                setReload(new Date().getTime());
                document.getElementById("request-day-off-button").hidden = true
                notify.show('Requested day off successfully');
            }).catch((err) => {
                console.log(err);
                notify.show('Error requesting day off');
            })
    }

    return (
        <div className="search-teacher-container">
            <div className={requestDayOff ? "d-none" : "search-teacherjob-filters left-menu-width"}>
                <div className="w-100 d-flex justify-content-center">
                    <SearchBar
                        placeholder="Search..."
                        altColours
                        onChange={onSearchKeyword}
                        value={searchKeyword}
                        className=" w-100 justify-content-center"
                    />
                </div>
                <hr className="my-3" />
                <div className="searchFilterRow">
                    <div className="filterColumn">
                        <h2 className="search-filter-subheading">Status</h2>
                        <ul className="search-teacher-categories">
                            {statusList.map((st) => {
                                return (
                                    <li
                                        id={st.value}
                                        key={st.value}
                                        onClick={onSearchStatus}
                                        style={{
                                            fontWeight: searchStatus === st.value ? "bold" : "normal",
                                        }}
                                    >
                                        {st.label}
                                    </li>
                                );
                            })}
                        </ul>
                    </div>
                    <div className="filterColumn">
                        <h2 className="search-filter-subheading">Date</h2>
                        <ul className="search-teacher-categories">
                            {dateList.map((d) => {
                                return (
                                    <li
                                        id={d.value}
                                        key={d.value}
                                        onClick={onSearchDate}
                                        style={{
                                            fontWeight: searchDate === d.value ? "bold" : "normal",
                                        }}
                                    >
                                        {d.label}
                                    </li>
                                );
                            })}
                        </ul>
                        <div
                            hidden={searchDate === "future" || searchDate === "in-progress"}
                        >
                            {" "}
                        </div>
                    </div>
                    <div className="filterColumn">
                        <h2 className="search-filter-subheading">
                            <p></p>Sort By
                        </h2>
                        <ul className="search-teacher-categories">
                            {sortList.map((s) => {
                                return (
                                    <li
                                        id={s.value}
                                        key={s.value}
                                        onClick={onSort}
                                        style={{
                                            fontWeight: sortType === s.value ? "bold" : "normal",
                                        }}
                                    >
                                        {s.label}
                                    </li>
                                );
                            })}
                        </ul>
                    </div>
                </div>
            </div>

            <div className="search-teacher-main">
                <div className="">
                    <InfiniteScroll
                        pageStart={1}
                        initialLoad={false}
                        key={keyLoad}
                        loadMore={fetchAllBookings}
                        hasMore={hasMore}
                        loader={isLoading ? <div className="loader" key={0}><Spinner small /></div> : null}
                    >
                        <div>
                            <div className='d-flex flex-wrap justify-content-center'>
                                {
                                    bookingsData.length > 0 ? (
                                        bookingsData.map((job, index) => {
                                            const jobCampus =
                                                allCampus.find((campus) => campus._id === job.campus_id) ||
                                                {};
                                            const jobInst =
                                                allInst.find(
                                                    (inst) => inst._id === jobCampus.institution_id
                                                ) || {};
                                            const classData =
                                                allClasses.find(
                                                    (theClass) => theClass.campus_id === job.campus_id
                                                ) || {};
                                            const refId = getRefId(job);
                                            return (
                                                //   new job component goes here
                                                <div key={index} className="d-flex align-items-stretch">
                                                    <span ref={refs[refId]} className="job-list-ref" />
                                                    <BookingCard
                                                        job={job}
                                                        inst={jobInst}
                                                        campus={jobCampus}
                                                        classData={classData}
                                                        requestDayOff={requestDayOff}
                                                        minWidth
                                                        submitResponse={(...args) => {
                                                            return submitResponse(
                                                                allBookings,
                                                                handleBookings,
                                                                ...args
                                                            );
                                                        }}
                                                        isAdmin={props.isViewAsAdmin}
                                                        onCancelJob={onCancelJob}
                                                        onAcceptJob={onAcceptJob}
                                                        onRejectJob={onRejectJob}
                                                        handleRequestDayOff={handleRequestDayOff}
                                                        teacher={props.isViewAsAdmin ? props.user : null}
                                                        qualifications={qualifications}
                                                    />
                                                </div>
                                            );
                                        })
                                    ) : (
                                        'No results found.'
                                    )
                                }
                            </div>
                        </div>
                    </InfiniteScroll>
                </div>
            </div>
            <JumpToTopButton />
        </div>
    )
}

export default TeacherJobListNewContent;